import React, { useEffect, useMemo, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { getCompanyLogoUrl } from '../utils/companyLogo';
import { getProfilePictureUrl } from '../utils/profilePicture';
import { profileApi } from '../services/api';

const ShareSocialPage = () => {
  const { member, user } = useAuth();
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    if (!member?.member_id) {
      setProfile(null);
      return undefined;
    }

    let cancelled = false;
    profileApi.getProfile(member.member_id)
      .then((response) => {
        if (!cancelled) setProfile(response.data);
      })
      .catch(() => {
        // The editor can still use the login session or welcome-email values.
        if (!cancelled) setProfile(null);
      });

    return () => {
      cancelled = true;
    };
  }, [member?.member_id]);

  const shareToolSrc = useMemo(() => {
    // Preserve the pre-filled values attached to a welcome-email link. A signed-in
    // member's current profile then overrides them, so new profile photos are used.
    const params = new URLSearchParams(window.location.search);
    const shareProfile = profile || member;
    const memberName = shareProfile?.individual_name || user?.full_name || params.get('memberName') || '';
    const companyName = shareProfile?.company_name || user?.company_name || params.get('companyName') || '';
    const cityName = shareProfile?.city || user?.city || params.get('cityName') || '';
    const countryName = shareProfile?.country || user?.country || params.get('countryName') || '';
    const profileImage =
      getProfilePictureUrl(shareProfile) ||
      shareProfile?.profile_image ||
      shareProfile?.photo_url ||
      shareProfile?.avatar_url ||
      getProfilePictureUrl(user) ||
      user?.profile_image ||
      user?.photo_url ||
      user?.avatar_url ||
      params.get('profileImage') ||
      '';
    const companyImage = getCompanyLogoUrl(shareProfile) || params.get('companyImage') || '';

    [
      ['memberName', memberName],
      ['companyName', companyName],
      ['cityName', cityName],
      ['countryName', countryName],
      ['profileImage', profileImage],
      ['companyImage', companyImage],
    ].forEach(([key, value]) => {
      if (value) params.set(key, value);
    });

    const query = params.toString();
    return `/share-social-tool.html${query ? `?${query}` : ''}`;
  }, [member, profile, user]);

  return (
    <div style={{ width: '100%', minHeight: '100vh', margin: 0, padding: 0, background: '#f3f6f9' }}>
      <iframe
        title="One Globe Alliance Social Share"
        src={shareToolSrc}
        style={{ width: '100%', minHeight: '100vh', border: 'none' }}
      />
    </div>
  );
};

export default ShareSocialPage;
